<template>
    <section id="cta-content-dosing">
        <div class="container">
            <div class="p-5">

            </div>
            <!-- <div class="button-dosing-cta pl-2 pr-2 pl-lg-0 pr-lg-0">
                <div class="buttons">
                    <a target="_blank" href="/JORNAY PM Dosing Guide (Digital).pdf" class="button">
                        <label class="m-0 mr-2 ">Download Dosing Guide</label>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20.082" height="20.082" viewBox="0 0 20.082 20.082">
                            <path id="download_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
                                d="M170.041-784.939l-6.276-6.276,1.757-1.82,3.263,3.263V-800h2.51v10.229l3.263-3.263,1.757,1.82Zm-7.531,5.021a2.417,2.417,0,0,1-1.773-.737,2.417,2.417,0,0,1-.737-1.773v-3.765h2.51v3.765h15.062v-3.765h2.51v3.765a2.417,2.417,0,0,1-.737,1.773,2.417,2.417,0,0,1-1.773.737Z"
                                transform="translate(-160 800)" fill="#fff" />
                        </svg>
                    </a>
                </div>
            </div> -->
        </div>
        <CTABanner
            :onlyBanner="true"
            :bannerData="{ bannerText: 'see safety', href: '/safety' }"
        />
    </section>
</template>

<script>
import CTABanner from '../CTABanner.vue';

export default {
    components: {
        CTABanner,
    },
    data() {
        return {};
    },
};
</script>
